import { Jornadas_2026_A } from "./2026_mens_a/JornadaSchedule";
import { Groups_2026_A } from "./2026_mens_a/GroupsList";
import { teamList_2026_A } from "./2026_mens_a/TeamsList";

import { Jornadas_2026_B } from "./2026_mens_b/JornadaSchedule";
import { Groups_2026_B } from "./2026_mens_b/GroupsList";
import { teamList_2026_B } from "./2026_mens_b/TeamsList";

import { Jornadas_2026_Womens } from "./2026_feminil/JornadaSchedule";
import { Groups_2026_Womens } from "./2026_feminil/GroupsList";
import { teamList_2026_Womens } from "./2026_feminil/TeamsList";

import WallALeague2026 from "./2026_mens_a/images/aleague.png";
import WallBLeague2026 from "./2026_mens_b/images/bleague.png";
import WallWomensLeague2026 from "./2026_feminil/images/wleague.png";

import Logo2026 from "./2026.svg";
import Logo2026White from "./2026-white.svg";

// ========================================================
// TORNEOS 2025
// ========================================================

import { Jornadas_2025_A } from "./2025_mens_a/JornadaSchedule";
import { Groups_2025_A } from "./2025_mens_a/GroupsList";
import { teamList_2025_mensA } from "./2025_mens_a/TeamsList";

import { Jornadas_2025_B } from "./2025_mens_b/JornadaSchedule";
import { Groups_2025_B } from "./2025_mens_b/GroupsList";
import { teamList_2025_mensB } from "./2025_mens_b/TeamsList";

import { Jornadas_2025_Womens } from "./2025_feminil/JornadaSchedule";
import { Groups_2025_womens } from "./2025_feminil/GroupsList";
import { teamList_2025_womens } from "./2025_feminil/TeamsList";

import WallALeague2025 from "./2025_mens_a/images/wallpaper.png";
import WallBLeague2025 from "./2025_mens_b/images/wallpaper.png";
import WallWomensLeague2025 from "./2025_feminil/images/wallpaper.png";

import Logo_2025 from "./2025.png";
import Logo_2025_white from "./2025-white.png";

// ========================================================
// TORNEOS ANTERIORES
// ========================================================

import Logo from "./Logo.webp";
import Logo_B from "./2024Logo.png";

import Wallpaper_A from "./mens__first_division/images/D1_MENS.jpg";
import Wallpaper_B from "./mens__a/images/FAIR_MENS_2.0.jpg";
import WomensWallpaper from "./FAIR_WOMENS.jpg";

import { Groups } from "./mens__a/GroupsList";
import { ActiveJornada, JornadaSchedule } from "./mens__a/JornadaSchedule";
import { teamList } from "./mens__a/TeamsList";

import { Groups__FIRST_DIVISION } from "./mens__first_division/GroupsList";
import { ActiveJornada_FIRST_DIVISION } from "./mens__first_division/JornadaSchedule";
import { teamList_old_men_first } from "./mens__first_division/TeamsList";

import { Groups__WOMEN } from "./womens/GroupsList";
import { ActiveJornada_WOMEN } from "./womens/JornadaSchedule";
import { teamList_old_fem } from "./womens/TeamsList";

// ========================================================
// ==DDDDDD========AAAA=====TTTTTTTTTTTT========AAAA=======
// ==DD===DD======AA==AA=========TT============AA==AA======
// ==DD====DD=====A====A=========TT============A====A======
// ==DD=====DD===AA====AA========TT===========AA====AA=====
// ==DD=====DD===AAAAAAAA========TT===========AAAAAAAA=====
// ==DD====DD====A======A========TT===========A======A=====
// ==DD===DD====AA======AA=======TT==========AA======AA====
// ==DDDDDD=====AA======AA=======TT==========AA======AA====
// ========================================================

export const basketball_tournaments_data = [
  // ========================================================
  // AMISTAD BASKETBALL 2026: A LEAGUE
  // ========================================================

  {
    isNew: true,

    // Info
    name: "Amistad Basketball 2026: A League",
    URL_name: "fdla-2026-a-league",
    thumbnailImage: WallALeague2026,
    tournamentLogoImage: Logo_2025_white,
    heroSectionImage: Wallpaper_A,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_2025,

    // Config
    sex: "male",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 2,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: true,
    isLocalData: true,

    teams: teamList_2026_A,
    groupNamePrefix: "1",
    groups: Groups_2026_A,
    jornadas: Jornadas_2026_A,
    activeJornadas: Jornadas_2026_A,
  },

  // ========================================================
  // AMISTAD BASKETBALL 2026: B LEAGUE
  // ========================================================

  {
    isNew: true,

    // Info
    name: "Amistad Basketball 2026: B League",
    URL_name: "fdla-2026-b-league",
    thumbnailImage: WallBLeague2026,
    tournamentLogoImage: Logo_2025_white,
    heroSectionImage: Wallpaper_A,
    // groupQualificationText:
    //   "Solo el primer lugar de cada grupo avanza a semifinales.",

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_2025,

    // Config
    sex: "male",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 1,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_2026_B,
    groupNamePrefix: "1",
    groups: Groups_2026_B,
    jornadas: Jornadas_2026_B,
    activeJornadas: Jornadas_2026_B,
  },

  // ========================================================
  // AMISTAD BASKETBALL 2026: WOMENS LEAGUE
  // ========================================================

  {
    isNew: true,

    // Info
    name: "Amistad Basketball 2026: Womens League",
    URL_name: "fdla-2026-womens-league",
    thumbnailImage: WallWomensLeague2026,
    tournamentLogoImage: Logo_2025_white,
    heroSectionImage: Wallpaper_A,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_2025,

    // Config
    sex: "female",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 4,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_2026_Womens,
    groupNamePrefix: "WOMEN'S LEAGUE",
    groups: Groups_2026_Womens,
    jornadas: Jornadas_2026_Womens,
    activeJornadas: Jornadas_2026_Womens,
  },

  // ========================================================
  // AMISTAD BASKETBALL 2025: A LEAGUE
  // ========================================================

  {
    isNew: true,

    // Info
    name: "Amistad Basketball: A League",
    URL_name: "fdla-2025-a-league",
    thumbnailImage: WallALeague2025,
    tournamentLogoImage: Logo_2025_white,
    heroSectionImage: Wallpaper_A,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_2025,

    // Config
    sex: "male",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 2,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_2025_mensA,
    groups: Groups_2025_A,
    activeJornadas: Jornadas_2025_A,
  },

  // ========================================================
  // AMISTAD BASKETBALL 2025: B LEAGUE
  // ========================================================

  {
    isNew: true,

    // Info
    name: "Amistad Basketball: B League",
    URL_name: "fdla-2025-b-league",
    thumbnailImage: WallBLeague2025,
    tournamentLogoImage: Logo_2025_white,
    heroSectionImage: Wallpaper_A,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_2025,

    // Config
    sex: "male",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 1,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_2025_mensB,
    groups: Groups_2025_B,
    jornadas: JornadaSchedule,
    activeJornadas: Jornadas_2025_B,
  },

  // ========================================================
  // AMISTAD BASKETBALL 2025: WOMENS LEAGUE
  // ========================================================

  {
    isNew: true,

    // Info
    name: "Amistad Basketball: Womens League",
    URL_name: "fdla-2025-womens-league",
    thumbnailImage: WallWomensLeague2025,
    tournamentLogoImage: Logo_2025_white,
    heroSectionImage: Wallpaper_A,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_2025,

    // Config
    sex: "female",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 4,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_2025_womens,
    groups: Groups_2025_womens,
    jornadas: Jornadas_2025_Womens,
    activeJornadas: Jornadas_2025_Womens,
  },

  // ========================================================
  // TORNEO ANTERIOR: 1ERA FUERZA
  // ========================================================

  {
    // Info
    name: "Torneo de Basketbol: 1ERA Fuerza",
    URL_name: "feria-de-la-amistad-mens-basketball-first-division",
    thumbnailImage: Wallpaper_A,
    tournamentLogoImage: Logo,
    heroSectionImage: Wallpaper_A,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_B,

    // Config
    sex: "male",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 2,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_old_men_first,
    groups: Groups__FIRST_DIVISION,
    jornadas: JornadaSchedule,
    activeJornadas: ActiveJornada_FIRST_DIVISION,
  },

  // ========================================================
  // TORNEO ANTERIOR: 2DA FUERZA
  // ========================================================

  {
    // Info
    name: "Torneo de Basketbol: 2DA Fuerza",
    URL_name: "feria-de-la-amistad-mens-basketball",
    thumbnailImage: Wallpaper_B,
    tournamentLogoImage: Logo,
    heroSectionImage: Wallpaper_B,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_B,

    // Config
    sex: "male",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 2,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList,
    groups: Groups,
    jornadas: JornadaSchedule,
    activeJornadas: ActiveJornada,
  },

  // ========================================================
  // TORNEO ANTERIOR: FEMENIL
  // ========================================================

  {
    // Info
    name: "Torneo de Basketbol: Femenil",
    URL_name: "feria-de-la-amistad-womens-basketball",
    thumbnailImage: WomensWallpaper,
    tournamentLogoImage: Logo,
    heroSectionImage: WomensWallpaper,

    location: "Lebaron",

    // Host
    host: "Feria de la Amistad",
    hostLogoImage: Logo_B,

    // Config
    sex: "female",
    pageColorVersion: "red",

    tournamentType: "groups_and_playoff",
    teamsToSurviveGroup: 4,

    pointsPerWin: 3,
    pointsPerDraw: 1,
    pointsPerDrawWin: 1,
    pointsPerLoss: 0,

    isCompleted: false,
    isLocalData: true,

    teams: teamList_old_fem,
    groups: Groups__WOMEN,
    jornadas: JornadaSchedule,
    activeJornadas: ActiveJornada_WOMEN,
  },
];
